module.exports = __webpack_public_path__ + "img/ds-one.28772ab6.png";